export default __webpack_public_path__ + "static/media/bol_scan_2.6fddb6a6.svg";